export enum LanguageTranslation {
  ENGLISH = 'en',
  SPANISH = 'es',
  JAPANESE = 'ja',
}
